import { render, staticRenderFns } from "./AdminAmenities.vue?vue&type=template&id=440a6736&scoped=true"
import script from "./AdminAmenities.vue?vue&type=script&lang=js"
export * from "./AdminAmenities.vue?vue&type=script&lang=js"
import style0 from "./AdminAmenities.vue?vue&type=style&index=0&id=440a6736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440a6736",
  null
  
)

export default component.exports